import React from 'react';

// Components //
import Callout from 'components/Callout';
import Text from 'components/Text';

const ErrorMessage = ({ text, ...props }) => {
  return (
    <Callout isSuccess {...props}>
      <Text color="white">
        <b>Success:</b> { text }
      </Text>
    </Callout>
  )
}

export default ErrorMessage
